import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Settings, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then(r => setStats(r.data)).catch(() => setStats({}));
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <p className="eyebrow">Admin Studio</p>
      <h1 className="mt-3 font-serif text-4xl text-jade font-light">Welcome back.</h1>
      <p className="mt-3 text-ink/65 text-[14px] font-light max-w-xl">
        Manage what travellers see and the enquiries that arrive. More tools (destinations, journeys, journal, media)
        will appear here in the next phases.
      </p>

      <div className="mt-12 grid md:grid-cols-3 gap-6">
        <div className="border border-mist p-6">
          <p className="eyebrow">Enquiries</p>
          <p className="mt-3 font-serif text-4xl text-jade font-light" data-testid="stat-enquiries">{stats?.enquiries ?? "—"}</p>
          <p className="mt-1 text-[12px] text-ink/55">Total received</p>
        </div>
        <div className="border border-mist p-6">
          <p className="eyebrow">Destinations</p>
          <p className="mt-3 font-serif text-4xl text-jade font-light" data-testid="stat-destinations">{stats?.destinations ?? "—"}</p>
          <p className="mt-1 text-[12px] text-ink/55">Live on the site</p>
        </div>
        <div className="border border-mist p-6">
          <p className="eyebrow">Journeys</p>
          <p className="mt-3 font-serif text-4xl text-jade font-light" data-testid="stat-journeys">{stats?.journeys ?? "—"}</p>
          <p className="mt-1 text-[12px] text-ink/55">Sample itineraries</p>
        </div>
      </div>

      <div className="mt-14">
        <p className="eyebrow">Quick actions</p>
        <div className="mt-5 space-y-3">
          <Link
            to="/studio/pages"
            data-testid="quick-action-pages"
            className="flex items-center justify-between border border-mist px-6 py-5 hover:border-jade transition-colors group"
          >
            <div className="flex items-center gap-4">
              <Settings size={18} className="text-jade" />
              <div>
                <p className="font-serif text-lg text-jade">Pages</p>
                <p className="text-[13px] text-ink/60">Edit homepage, about, contact copy + per-page SEO</p>
              </div>
            </div>
            <ArrowRight size={18} className="text-ink/40 group-hover:text-copper transition-colors" />
          </Link>
          <Link
            to="/studio/testimonials"
            data-testid="quick-action-testimonials"
            className="flex items-center justify-between border border-mist px-6 py-5 hover:border-jade transition-colors group"
          >
            <div className="flex items-center gap-4">
              <Settings size={18} className="text-jade" />
              <div>
                <p className="font-serif text-lg text-jade">Testimonials</p>
                <p className="text-[13px] text-ink/60">Featured traveller quotes shown on the homepage</p>
              </div>
            </div>
            <ArrowRight size={18} className="text-ink/40 group-hover:text-copper transition-colors" />
          </Link>
          <Link
            to="/studio/team"
            data-testid="quick-action-team"
            className="flex items-center justify-between border border-mist px-6 py-5 hover:border-jade transition-colors group"
          >
            <div className="flex items-center gap-4">
              <Settings size={18} className="text-jade" />
              <div>
                <p className="font-serif text-lg text-jade">Team</p>
                <p className="text-[13px] text-ink/60">Specialists listed on the About page</p>
              </div>
            </div>
            <ArrowRight size={18} className="text-ink/40 group-hover:text-copper transition-colors" />
          </Link>
          <Link
            to="/studio/site-settings"
            data-testid="quick-action-site-settings"
            className="flex items-center justify-between border border-mist px-6 py-5 hover:border-jade transition-colors group"
          >
            <div className="flex items-center gap-4">
              <Settings size={18} className="text-jade" />
              <div>
                <p className="font-serif text-lg text-jade">Site Settings</p>
                <p className="text-[13px] text-ink/60">Brand, contact, footer, ABTA L5630 and ATOL 11288 details</p>
              </div>
            </div>
            <ArrowRight size={18} className="text-ink/40 group-hover:text-copper transition-colors" />
          </Link>
        </div>
      </div>
    </div>
  );
}
